<template>
  <div id="contact" class="content container">
    <h3>Contact Us</h3>
    <!-- <p>You can email us at garagerats@outlook.com</p> -->
    <ul>
      <li><strong>President:</strong>
        <ul>
          <li>Bud Jordan - (303) 859-3213</li>
        </ul>
      </li>
      <li><strong>Vice President:</strong>
        <ul>
          <li>Bill Fletcher - (303) 246-4323</li>
        </ul>
      </li>
      <li><strong>Secretary/Treasurer:</strong>
        <ul>
          <li>Lisa Carlson - (303) 947-4197</li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ContactView'
}
</script>
